
import React from "react"
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const MenuElement = styled(NavLink)`
&:hover {
    color: ${props => props.theme.colors.orange};
  }
&.active {
    color: ${props => props.theme.colors.orange};
}
text-decoration: none;
color:${props => props.theme.colors.brown};
float: left;
margin: 0px 15px 0px 15px;
padding: 10px;
cursor:pointer;
`
const MenuBar = styled.div`
display:inline-block;
background-color:${props=>props.theme.colors.black};
text-align:center;
width:100%;
margin: 5px 0px 5px 0px;
padding:25px 10px 25px 10px;
`

const Login = styled.div`
padding: 0px 0px 25px 0px;
width:100%;
text-align:right;
`

//<MenuElement reloadDocument to="/notices_zotero/20/0"> Notices - Zotero </MenuElement>

const  NavBar = () => {

    const initialisation = () => {
        const dateValiditeJeton = new Date(localStorage.getItem('date_expired'))
        if  (localStorage.getItem('email') && (dateValiditeJeton > Date.now())){
            return true
        } else {
            localStorage.clear()
            return false
        }
    }

    const actif = initialisation()

    const identite = () => {
        if  (actif){
            return (<span>Connecté en tant que {localStorage.getItem('email')}</span>)
        }
        return
    }

    const handleLogout = () => {
        localStorage.clear()
    }

    const lien = () => {
        if (! actif)
            return (<MenuElement reloadDocument to='/login'>(Se connecter)</MenuElement>)
        return (<MenuElement reloadDocument to='/' onClick={handleLogout}>(Se déconnecter)</MenuElement>)
    }

    return (
        <>
        {lien()}
        <MenuBar>
            <MenuElement reloadDocument to="/"> Accueil </MenuElement>
            <MenuElement reloadDocument to="/theatre"> Théatres</MenuElement>
            <MenuElement reloadDocument to="/notice"> Notices </MenuElement>
            <MenuElement reloadDocument to="/motclef"> Motclefs </MenuElement>
            <MenuElement reloadDocument to="/auteur"> Auteurs </MenuElement>
            <MenuElement reloadDocument to="/collaborateur"> Collaborateurs </MenuElement>
            <MenuElement reloadDocument to="/phototheatre"> Photos </MenuElement>
        </MenuBar>
        <Login>{identite()}</Login>
        </>

    );
}

export default NavBar;